import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ConcatPipe } from '@markant-platform/shared/util-pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { Price } from '@markant-platform/cartridge/model';
import { isBulkPrice } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-price-metadata',
  standalone: true,
  imports: [ConcatPipe, TranslocoPipe],
  templateUrl: './price-metadata.component.html',
  styleUrl: './price-metadata.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceMetadataComponent {
  price = input.required<Price>();

  $metadata = computed(() => {
    if (isBulkPrice(this.price())) {
      return 'cartridge.billingPeriod.LABEL';
    }
    return `cartridge.priceModel.${this.price().priceModel}`;
  });
}
